import { SuiThemeMode } from '@semeris/ui';

export type ThemeMode = SuiThemeMode;

export function normalizeThemeMode(value: string | null | undefined): ThemeMode {
  switch (value) {
    case 'dark':
    case 'dark-theme':
      return 'dark';
    case 'light':
    case 'light-theme':
      return 'light';
    default:
      return 'system';
  }
}
